"use strict";

module.exports = require("./lib/react-console.js");



//////////////////
// WEBPACK FOOTER
// ./~/react-console-component/main.js
// module id = 632
// module chunks = 0